import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `0 ${scale.xs}`,

    [media.s.up]: {
      padding: `0 ${scale.s}`,
    },
  },
  faqContainer: {
    borderBottom: `${colors.light_grey} 2px solid`,
    padding: scale.s,
    paddingBottom: scale.xs,
    paddingLeft: 0,
    width: '100%',
  },
  title: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    fontSize: font.xl,
    width: '100%',
    '&:hover': {
      color: colors.sas.primary_dark,
    },
  },
  content: {
    maxHeight: 0,
    overflow: 'hidden',
    transition: 'all 1s ease-in-out',
  },
  showContent: {
    maxHeight: '1000px',
  },
  icon: {
    marginLeft: scale.xs,
  },
});
